"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../../../projects/angular-sdk/src/4d-mapper.service");
const i2 = require("../xs/services/events/application-events.service");
const i3 = require("./measurement-helper.service");
const i4 = require("./controllers/scene-controller.service");
DEBUG_1.DEBUG.open('/service/plugin-manager.ts');
const Constants_1 = require("../commons/Constants");
const _4d_mapper_1 = require("4d-mapper");
const environment_1 = require("@src/environments/environment");
const cesium_renderer_wms_1 = require("../v2/commons/cesium/cesium-renderer-wms");
const event_listener_interface_1 = require("../xs/interfaces/event-listener.interface");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const public_3d_renderer_1 = require("../v2/commons/cesium/public-3d-renderer");
const annotation_renderer_1 = require("../v2/commons/cesium/annotation-renderer");
const measurement_helper_service_1 = require("./measurement-helper.service");
const scene_controller_service_1 = require("./controllers/scene-controller.service");
const cesium_renderer_arcgis_1 = require("../v2/commons/cesium/cesium-renderer-arcgis");
const cesium_renderer_wfs_1 = require("../v2/commons/cesium/cesium-renderer-wfs");
const cesium_renderer_wtms_1 = require("../v2/commons/cesium/cesium-renderer-wtms");
const Cesium = window.Cesium;
class CesiumMapService {
    constructor(fourD, applicationEvents, measureHelper, sceneController) {
        this.fourD = fourD;
        this.applicationEvents = applicationEvents;
        this.measureHelper = measureHelper;
        this.sceneController = sceneController;
        this.__ID = null;
        this.__EVENTS = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugCounter = 0;
        // the element used for the Cesium map
        // canvas: HTMLElement = null;
        // our Cesium viewer
        // viewer:any = null;
        // imagery provider for Cesium ellipsoid
        // imageryProvider:any = null;
        // 4DMapper Cesium helper
        // helper:FourdCesiumHelper = null;
        // all our globels / maps
        this.globes = {};
        this.interval = null;
        this.realtime = null;
        this.mousePosition = null;
        this.testAttempts = null;
        this.keepTestingForScene = false;
        DEBUG_1.DEBUG.log('/service/map-viewer.service.ts');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        if (this.debug) {
            console.log("%c map-viewer.service CONSTRUCTOR()", Constants_1.Constants._yellow);
        }
        let me = this;
        document.addEventListener('mousemove', (event) => {
            me.mousePosition = Math.round(event.clientX + event.clientY);
        });
        this.interval = setInterval(() => {
            Object.keys(this.globes).forEach(key => {
                this.globes[key].timePulse = 10;
                // var now = Cesium.getTimestamp();
                this.globes[key].timeLast = this.globes[key].timeNow;
                this.globes[key].mouseLast = this.globes[key].mouseNow;
                this.globes[key].timeNow = this.globes[key].viewer.scene._frameState.frameNumber; // Cesium.getTimestamp();
                this.globes[key].mouseNow = this.mousePosition;
                // this.globes[key].timeLast = this.globes[key].viewer.camera.timeSinceMoved; // _lastCameraMoveTime;
                this.globes[key].timeSince = this.globes[key].timeNow - this.globes[key].timeLast; // now - this.globes[key].viewer._lastCameraMoveTime;
                if (this.globes[key].mouseNow != this.globes[key].mouseLast) {
                    if (this.globes[key].timeSince < 1) {
                        this.globes[key].timeDown++;
                    }
                    else {
                        this.globes[key].timeDown = 0;
                    }
                }
                // console.log('!!!!',this.globes[key].viewer);
                // if (    !cameraMovedInLastSecond &&    !cesium.viewer.clock.shouldAnimate  ) {    if (cesium.verboseRendering) {      console.log("stopping rendering @ " + getTimestamp());    }    cesium.viewer.useDefaultRenderLoop = false;    // custom message then hard refresh the broswer using location.reload(true);  }
            });
        }, 500);
        /* this.realtime = setInterval( () => {
          Object.keys(this.globes).forEach( key => {
            if ( this.globes[key].timePulse > 0 ) {
              this.globes[key].timePulse--;
            }
          });
        }, 500 ); */
    }
    /* inject ( viewer:any = null ) {
      if ( this.debug ) { console.log ( "%c map-viewer.service inject()", Constants._yellow ); }
      this.viewer = viewer;
    } */
    init(name = 'base', canvas) {
        if (this.debug) {
            console.log("%c map-viewer.service init()", Constants_1.Constants._yellow, name, this.globes);
        }
        if (!this.globes[name]) {
            this.globes[name] = {
                events: name == 'base' ? true : false,
                alive: false,
                timeSince: 0,
                timeNow: 0,
                mouseNow: null,
                timeLast: 0,
                mouseLast: null,
                timePulse: 0,
                timeDown: 0,
                canvas: canvas,
                viewer: null,
                imageryProvider: null,
                helper: null
            };
        }
        const map = this.globes[name];
        if (this.debug) {
            console.log("%c map-viewer.service init() start", Constants_1.Constants._yellow, name, map, this.globes);
        }
        if (map.events) {
            this.applicationEvents.triggerInit('mapViewer', null, this.__ID);
        }
        this.initImageryProvider(name);
        if (map.events) {
            this.applicationEvents.triggerStart('mapViewer', null, this.__ID);
        }
        this.initViewer(name);
        this.initHelper(name);
        // also track when the scene is ready (the Scene might be a few milliseconds after 
        // the viewer is ready, so some might want to hook into this one instead)
        if (map.events) {
            this.isSceneReady(name);
        }
        if (this.debug) {
            console.log("%c map-viewer.service init() done", Constants_1.Constants._yellow, name, map, this.globes);
        }
    }
    getMap(name = 'base') {
        const map = this.globes[name];
        if (map) {
            return map;
        }
        return null;
    }
    // Note: make this one a generic service of the Eventify() class / service
    isSceneReady(name = 'base', reset = true) {
        if (reset) {
            this.keepTestingForScene = true;
            this.testAttempts = 15;
            if (this.debug) {
                console.log('isSceneReady() reset 5');
            }
        }
        let test1 = null, test2 = null, test3 = null;
        const map = this.globes[name];
        if (map.viewer) {
            test1 = map.viewer['scene'] ? true : false;
            test2 = map.viewer['dataSources'] ? true : false;
            test3 = true; // this.viewer['defaultDataSource'] ? true : false;
        }
        if (!reset && test1 && test2 && test3) {
            if (this.debug) {
                console.log('isSceneReady() READY', this.testAttempts);
            }
            if (map.events) {
                this.applicationEvents.triggerEnd('mapViewer', { viewer: map.viewer, helper: map.helper }, this.__ID);
            }
            this.keepTestingForScene = false;
        }
        if (this.keepTestingForScene) {
            if (this.testAttempts--) {
                let me = this;
                if (this.debug) {
                    console.log('isSceneReady() have another go...', this.testAttempts, test1, test2, test3);
                }
                setTimeout(() => { me.isSceneReady(name, false); }, 500);
            }
            else {
                this.keepTestingForScene = false;
                if (this.debug) {
                    console.log('giving up testing for sceneReady');
                }
            }
        }
    }
    initImageryProvider(name = 'base') {
        const map = this.globes[name];
        // default imagery provider
        var mapboxApiKey = 'pk.eyJ1IjoiZ2VvbWF0aWNzIiwiYSI6IjRDSmd3UWcifQ.YEoSImxSElTq1uPwjZnrNw';
        map.imageryProvider = new Cesium.MapboxImageryProvider({
            url: 'https://api.mapbox.com/v4',
            mapId: 'mapbox.satellite',
            accessToken: mapboxApiKey,
            maximumLevel: 16,
            minimumLevel: 0
        });
        if (this.debug) {
            console.log("%c map-viewer.service initImageryProvider()", Constants_1.Constants._yellow, map.imageryProvider);
        }
    }
    createReport(name = 'base') {
        const map = this.globes[name];
        let m = {};
        ['events', 'alive', 'timeNow', 'timeLast', 'timeDown'].forEach(mp => { m[mp] = map[mp]; });
        return m;
        // this.sceneController.reportComplexAction ( 'color-manager::render-colors', { name:name, config:config, map:m });
    }
    initViewer(name = 'base') {
        const map = this.globes[name];
        const timeline = false;
        let config = {
            homeButton: false,
            sceneModePicker: false,
            navigationInstructionsInitiallyVisible: false,
            geocoder: false,
            baseLayerPicker: false,
            navigationHelpButton: false,
            fullscreenButton: false,
            scene3DOnly: true,
            showRenderLoopErrors: environment_1.environment.production,
            imageryProvider: map.imageryProvider,
            // requestRenderMode: true,
            // maximumRenderTimeChange: Infinity,
            //NOTE: disable Cesium/leaflet timelines/animations until further notice
            timeline: timeline,
            timeControlsInitiallyVisible: timeline,
            animation: timeline,
            selectionIndicator: false,
            infoBox: false,
            /*terrainProvider: Cesium.createWorldTerrain({
              requestWaterMask : true,
              requestVertexNormals: true // true //Needed to visualize slope
            })*/
            shouldAnimate: true
        };
        try {
            map.viewer = new Cesium.Viewer(map.canvas, config);
        }
        catch (error) {
            console.error("Couldn't instantiate Cesium viewer", map);
        }
        this.sceneController.reportComplexAction('map-viewer::init-viewer', { name: name, config: config, map: this.createReport(name) });
        // no double-click
        map.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        // no credit display
        // disabled; using CSS instead to hide it, otherwise Cesium throws a mickey when destroying the viewer
        // this.viewer.scene.frameState.creditDisplay.container.remove();
        //Set the time to position of the sun
        map.viewer.clock.currentTime = Cesium.JulianDate.fromDate(new Date());
        map.viewer.clock.multiplier = 1;
        map.viewer.clock.shouldAnimate = true;
        // picking and display
        // NOTE: in the future, make this 'true' when we have a terrain, otherwise 'false' (probably in the SceneController)
        map.viewer.scene.globe.depthTestAgainstTerrain = true;
        map.viewer.scene.useDepthPicking = true;
        map.viewer.scene.pickTranslucentDepth = true;
        map.alive = true;
        if (this.debug) {
            console.log("%c map-viewer.service initViewer()", Constants_1.Constants._yellow, map);
        }
    }
    initHelper(name = 'base') {
        const map = this.globes[name];
        if (this.debug) {
            console.log("%c map-viewer.service initHelper()", Constants_1.Constants._yellow, map);
        }
        map.helper = new _4d_mapper_1.FourdCesiumHelper(this.fourD, map.viewer);
        map.helper.registerRenderer(_4d_mapper_1.Annotation, '*', new annotation_renderer_1.AnnotationRenderer(map.helper));
        map.helper.registerRenderer(_4d_mapper_1.Transform, 'wms-remote', new cesium_renderer_wms_1.WMSTransformRenderer(map.viewer));
        map.helper.registerRenderer(_4d_mapper_1.Transform, 'arcgis-remote', new cesium_renderer_arcgis_1.ArcGisTransformRenderer(map.viewer));
        map.helper.registerRenderer(_4d_mapper_1.Transform, 'wfs-remote', new cesium_renderer_wfs_1.WFSTransformRenderer(map.viewer));
        map.helper.registerRenderer(_4d_mapper_1.Transform, 'wmts-remote', new cesium_renderer_wtms_1.WMTSTransformRenderer(map.viewer));
        map.helper.registerRenderer(_4d_mapper_1.Transform, 'public-3d', new public_3d_renderer_1.Public3DRenderer(map.helper));
        // moved here from mapService
        // this.helper.registerRenderer(Annotation,'*',new AnnotationRenderer(this.helper))
        // this.helper.registerRenderer(Transform,'wms-remote',new WMSTransformRenderer(this.viewer))
        // this.helper.registerRenderer(Transform,'arcgis-remote',new ArcGisTransformRenderer(this.viewer))
        // this.helper.registerRenderer(Transform,'wfs-remote',new WFSTransformRenderer(this.viewer))
        // this.helper.registerRenderer(Transform,'wmts-remote',new WMTSTransformRenderer(this.viewer))
        // this.helper.registerRenderer(Transform,'public-3d',new Public3DRenderer(this.helper))
    }
    destroy(name = 'base') {
        let map = this.globes[name];
        if (this.debug) {
            console.log("%c map-viewer.service destroy()", Constants_1.Constants._yellow, name, map);
        }
        if (map.events) {
            this.applicationEvents.triggerStart('mapViewerDestroy', null, this.__ID);
        }
        if (map.viewer) {
            if (map.viewer.entities) {
                map.viewer.entities.removeAll();
            }
            if (map.events) {
                this.applicationEvents.triggerEnd('mapViewerDestroy', null, this.__ID);
                map.events = null;
            }
            try {
                map.viewer.destroy();
                map.viewer = null;
            }
            catch (e) {
                console.log('error destroying viewer', e);
            }
        }
        map.helper = null;
        map.imageryProvider = null;
        map.canvas = null;
        map.alive = false;
        map = null;
        this.globes[name] = null;
        delete this.globes[name];
        if (this.debug) {
            console.log("%c map-viewer.service destroy() DESTROYED", Constants_1.Constants._yellow, map, this.globes);
        }
    }
}
CesiumMapService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CesiumMapService_Factory() { return new CesiumMapService(i0.ɵɵinject(i1.FourDService), i0.ɵɵinject(i2.XsApplicationEventsService), i0.ɵɵinject(i3.MeasurementHelperService), i0.ɵɵinject(i4.SceneControllerService)); }, token: CesiumMapService, providedIn: "root" });
exports.CesiumMapService = CesiumMapService;
